import JwtService from '@/store/jwt.service';

const backend = () => (process.env.VUE_APP_BACKEND_URL || 'https://backend.micrologos.com.br/').replace(/\/?$/, '/');

// Requisições de pagamento nunca entram em fila offline nem têm retry automático.
async function requisitar(caminho, dados, autenticado = true, metodo = 'POST') {
  if (navigator.onLine === false) throw new Error('Conecte-se à internet para consultar ou realizar pagamentos.');
  const token = autenticado ? JwtService.getToken() : null;
  if (autenticado && !token) throw new Error('Entre novamente no aplicativo.');
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 30000);
  try {
    const response = await fetch(new URL(caminho, backend()), {
      method: metodo, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Token ${token}` } : {}) },
      ...(metodo === 'POST' ? { body: JSON.stringify(dados) } : {})
    });
    const data = await response.json();
    if (!response.ok || !data.resultado) throw new Error(data.msg || 'Não foi possível consultar o pagamento.');
    return data.dados;
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('A resposta demorou mais que o esperado. Atualize a situação antes de tentar novamente.');
    throw error;
  } finally { clearTimeout(timer); }
}

export const consultarTitulo = dados => requisitar('paylogosAppCheckout/consultar', dados);
export const prepararCheckout = dados => requisitar('paylogosAppCheckout/abrir', dados);
export const comprarProjeto = dados => requisitar('paylogosAppCheckout/comprarProjeto', dados);
export const iniciarCompra = dados => requisitar('paylogosAppCheckout/iniciarCompra', dados, false);
export const confirmarCompra = dados => requisitar('paylogosAppCheckout/confirmarCompra', dados, false);

export function urlCheckout(valor) {
  const url = new URL(valor);
  if (url.protocol !== 'https:' || url.username || url.password || !/\/pagar\/[a-f0-9]{32}\.[a-f0-9]{64}$/.test(url.pathname)) throw new Error('Endereço de pagamento inválido. Contate o estabelecimento.');
  return url;
}
export function acessarCheckout(cobranca) { window.location.assign(urlCheckout(cobranca.url).href); }
export function guardarCompra(hash, resultado) {
  if (resultado.cobranca) urlCheckout(resultado.cobranca.url);
  sessionStorage.setItem(`pay-compra:${hash}`, JSON.stringify(resultado));
}
export function recuperarCompra(hash) {
  try {
    const r = JSON.parse(sessionStorage.getItem(`pay-compra:${hash}`));
    if (r?.cobranca) urlCheckout(r.cobranca.url);
    return r;
  } catch { return null; }
}
export function consultarCompra(cobranca) {
  const url = urlCheckout(cobranca.url);
  return requisitar(`payPublico/consultar/${encodeURIComponent(url.pathname.split('/').pop())}`, null, false, 'GET');
}

export const situacaoTitulo = titulo => titulo.PAY?.situacao || (Number(titulo.VALOR_PAGO || 0) >= Number(titulo.VALOR) || String(titulo.LIQUIDACAO_TOTAL) === '1' ? 'Pago' : 'Pendente');
export const tituloPago = titulo => titulo.PAY ? titulo.PAY.quitado || titulo.PAY.pagamento_confirmado : situacaoTitulo(titulo) === 'Pago';
export const saldoTitulo = titulo => tituloPago(titulo) ? 0 : (titulo.PAY?.saldo ?? Math.max(0, Number(titulo.VALOR || 0) - Number(titulo.VALOR_PAGO || 0)));
export const referenciaTitulo = titulo => ({ name: 'pendencia', query: { empresa: String(titulo.ID_EMITENTE_ML), titulo: String(titulo.ID_FLUXO_DE_CAIXA) } });
